import type { ProductType } from "./product.config";

export interface ProductLanguageConfig {
  speechLocale: string;
  realtimeTranscriptionLanguage: string;
}

const DEFAULT_LANGUAGE_CONFIG: ProductLanguageConfig = {
  speechLocale: "en-US",
  realtimeTranscriptionLanguage: "en",
};

const PRODUCT_LANGUAGE_CONFIG_MAP: Record<ProductType, ProductLanguageConfig> = {
  meetings: {
    speechLocale: "en-US",
    realtimeTranscriptionLanguage: "en",
  },
  interview: {
    speechLocale: "en-US",
    realtimeTranscriptionLanguage: "en",
  },
  recruiters: {
    speechLocale: "en-US",
    realtimeTranscriptionLanguage: "en",
  },
  english: {
    speechLocale: "en-US",
    realtimeTranscriptionLanguage: "en",
  },
  french: {
    speechLocale: "fr-FR",
    realtimeTranscriptionLanguage: "fr",
  },
};

export const getProductLanguageConfig = (
  productId: ProductType | string
): ProductLanguageConfig => {
  return (
    PRODUCT_LANGUAGE_CONFIG_MAP[productId as ProductType] ||
    DEFAULT_LANGUAGE_CONFIG
  );
};
